import { render, staticRenderFns } from "./zh.vue?vue&type=template&id=0f3752d5&scoped=true&"
import script from "./zh.vue?vue&type=script&lang=js&"
export * from "./zh.vue?vue&type=script&lang=js&"
import style0 from "./zh.vue?vue&type=style&index=0&id=0f3752d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3752d5",
  null
  
)

export default component.exports